import { configure } from "mobx";

configure({
  enforceActions: "never",
});

import app from "./app";
import argument from "./argument";
import balances from "./balances";
import market from "./market";
import user from "./user";
import currency from "./currency";

const store = {
  app,
  argument,
  balances,
  market,
  user,
  currency,
};

export default store;
